import { useContext } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import { GallectionType } from '../../types/gallection';
import { isSpecialStuckGallection } from '../../MediaPopup/helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isGroup } from '../../User/helpers';
import { normalizePremiumFolderData } from '../normalizePremiumFolderData';
import { useCurrentUser } from './useCurrentUser';

export default function useIsSellableAsPremiumGallery(
  currentFolder?: PapiGallection,
  hasSubfolders?: boolean
): boolean {
  const isMobile = useContext(MobileContext);
  const currentUser = useCurrentUser();

  if (!currentFolder) {
    return false;
  }

  const isOwner = currentFolder?.owner.userId === currentUser.userId;
  const isGallery = currentFolder?.type === GallectionType.GALLERY;
  const { isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(
    currentFolder?.premiumFolderData
  );

  return (
    isOwner &&
    isGallery &&
    !isGroup(currentFolder?.owner) &&
    !currentFolder?.parentId && // galleries with subfolders are not sellable
    !isMobile && // only desktop
    !isWatchToAccess && // watch-only galleries are not sellable
    !isPaidFolder && // already configured as premium
    !currentFolder.hasSubfolders && // galleries with subfolders are not sellable
    !hasSubfolders && // this checks for current state in case subgallery was just added
    !isSpecialStuckGallection(currentFolder) // special helper to find FEATURED | ALL
  );
}
